import * as React from 'react';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { fetchNews } from 'src/helpers/api';

interface IAdminNewsState {
  state: 'idle' | 'fetching';
  page: number;
  totalPages: number;
  items: INewsListItem[];
}

interface IAdminNewsContext extends IAdminNewsState {
  fetchList: (page?: number) => void;
}

const Context = React.createContext({} as IAdminNewsContext);

export const AdminNewsProvider = (props: object) => {
  const [state, setState] = React.useState<IAdminNewsState>({
    state: 'idle',
    page: 1,
    totalPages: 0,
    items: []
  });

  const fetchList = (page: number = 1) => {
    setState({ ...state, state: 'fetching' });
    fetchNews(page, 10, true).then(response => {
      setState({
        ...state,
        state: 'idle',
        page: response.page,
        totalPages: response.totalPages,
        items: response.newsList
      });
    });
  };

  return <Context.Provider {...props} value={{ ...state, fetchList }} />;
};

export const useAdminNews = () => React.useContext(Context);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/AdminNews/Context.tsx